@charset "UTF-8";

/* src/app/features/player/components/player-controls/player-controls.component.scss */
::ng-deep .p-slider {
  height: 8px !important;
  background-color: var(--player_progress_bar_background) !important;
  border-radius: 4px;
  cursor: pointer;
}
::ng-deep .p-slider.p-slider-vertical {
  width: 8px !important;
}
::ng-deep {
}
::ng-deep .p-slider-range {
  background-color: var(--highlight_primary) !important;
}
::ng-deep {
}
::ng-deep .p-slider-handle {
  background-color: var(--highlight_primary) !important;
  border: 2px solid var(--player_progress_bar_background) !important;
}
::ng-deep {
}
::ng-deep .p-slider-handle:hover,
::ng-deep .p-slider-handle:focus,
::ng-deep .p-slider-handle:focus-visible {
  box-shadow: 0 0 0 4px var(--highlight_primary_3) !important;
  outline: 0 none !important;
}
.controls-container.desktop {
  padding: 20px;
}
.controls-container.mobile {
  display: flex;
  flex-direction: column;
  padding: 16px;
}
.controls-container .title {
  margin-left: 15px;
}
.controls-container .timeline-container {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}
.controls-container .timeline-container .timeline {
  width: 100%;
}
.controls-container .time {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 13px;
}
.controls-container .seasons-episodes-container {
  position: relative;
  display: inline-block;
}
.controls-container .seasons-episodes-container:hover player-controls-series-episodes {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  pointer-events: auto;
}
.controls-container .volume-container {
  position: relative;
  display: inline-block;
}
.controls-container .volume-container .volume-component {
  position: absolute;
  right: 11px;
  bottom: 40px;
  z-index: 10;
  padding-bottom: 20px;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0.25s ease;
}
.controls-container .volume-container .volume-component .slider-wrapper {
  padding: 15px 10px 15px 10px;
  background-color: var(--background_primary_8);
  border-radius: 15px;
}
.controls-container .volume-container:hover .volume-component {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  pointer-events: auto;
}
.controls-container .settings-container {
  position: relative;
  display: inline-block;
}
.controls-container .settings-container:hover player-controls-settings {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
  pointer-events: auto;
}
/*# sourceMappingURL=player-controls.component.css.map */
